var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"500px"},attrs:{"id":"map-heat"}})
}
var staticRenderFns = []

export { render, staticRenderFns }